import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

function OfferCard({ offer }) {
    const [rounded, setRounded] = useState(0);

    const zoomSize = useSelector((state) => state.storefront.zoomSize);

    useEffect(() => {
        setRounded((zoomSize/100)*24);
    }, [zoomSize]);

    return (
        <div style={{ borderRadius: `${rounded}px` }} className='w-[45%] h-auto overflow-hidden shrink-0 border border-[#E2E2E2]'>
            <img className='w-full h-auto' src={offer?.couponImage} alt={offer.couponName} />
        </div>
    );
}

export default OfferCard